// #region Custom Enumerations

// #region Download Format Enum

export enum DownloadFormat {
    Unknown = -1,
    PDF = 0,
    Excel = 1,
    ZIP = 2,
    VCARD = 3,
    JPG = 4,
    PNG = 5,
    DOCX = 6,
}

// #endregion

// #region Http Method Enum

export enum HttpMethod {
    GET = 0,
    POST = 1,
    POST_FORMDATA = 2,
}

// #endregion

// #endregion
